// extracted by mini-css-extract-plugin
export var closeButton = "_2v-3";
export var header = "_2v-0";
export var link = "_2v-1";
export var retryButton = "_2v-2";